export default __webpack_public_path__ + "static/media/Fictiv(1).acdf4d74.png";